<template>
  <el-dialog
    :visible="visible"
    :width="isMobile ? '300px' : '475px'"
    append-to-body
    :close-on-click-modal="false"
    class="status-modal"
    @open="beforeOpen"
    @close="beforeClose"
  >
    <loader-wrapper v-if="response && history" :loading="loading || isLoading">
      <el-row class="row-wrap">
        <el-col :span="24">
          <span>Данные заявки: </span>
          <span class="date-at">#{{ response.id }}</span>
          <p class="resp-time">
            Дата
            {{ dateToFormat(response.created_at, 'onlyDateWithShortYear') }}
          </p>
        </el-col>
      </el-row>
      <el-row class="row-wrap">
        <el-col v-if="next" :span="24">
          <span>
            УСТАНОВИТЬ ВРЕМЯ
            {{ next.length === 1 ? statuses[next[0]].text : '' }}:
          </span>
          <p v-if="next.length > 1">
            <el-radio-group v-model="radio">
              <el-radio v-for="id in next" :key="id" :label="id">
                {{ statuses[id].text }}
              </el-radio>
            </el-radio-group>
          </p>
          <span class="set-date-wrap">
            <el-date-picker
              v-model="date"
              type="datetime"
              placeholder="Выберите дату и время"
              prefix-icon="el-icon-date"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
            />
            <el-button
              class="set-btn"
              type="primary"
              :disabled="!date"
              @click="setDate()"
            >
              Установить
            </el-button>
          </span>
        </el-col>
      </el-row>
      <el-row class="row-wrap">
        <el-col :span="24">
          <span>История рейса:</span>
          <el-timeline>
            <el-timeline-item
              v-for="id in history"
              :key="id"
              color="#00C041"
              :timestamp="getDate(statuses[id].field)"
            >
              {{ statuses[id].title }}
              <el-button
                v-if="id > 0"
                type="success"
                icon="el-icon-edit"
                size="mini"
                circle
                @click="editId = id"
              />
              <div v-else class="response__author">{{ responseAuthor }}</div>
            </el-timeline-item>
          </el-timeline>
        </el-col>
      </el-row>

      <el-row v-if="response['master-approve']" class="row-wrap">
        <el-col :span="24" class="approve">
          <div class="approve__title">ОТКЛИК ПОДТВЕРЖДЕН</div>
          <div>{{ response['master-approve'].user_author_name }}</div>
          <div class="approve__time">
            {{ dateToFormat(response['master-approve'].created_at) }}
          </div>
        </el-col>
      </el-row>

      <el-row v-if="response.deleted_at" class="row-wrap">
        <el-col :span="24" class="approve">
          <div class="approve__title">ОТКЛИК УДАЛЁН</div>
          <div>{{ response.deleted_by }}</div>
          <div class="approve__time">
            {{ dateToFormat(response.deleted_at) }}
          </div>
        </el-col>
      </el-row>
    </loader-wrapper>
    <edit-status-modal
      v-if="response"
      :id="editId"
      :date="editDate || ''"
      @change="setDate"
      @close="editId = -1"
    />
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapGetters } from 'vuex'
import { pickerOpt } from '@/datas/consts'
import { statuses } from '@/datas/responseStatuses'
import EditStatusModal from '@/views/LoadDay/Modals/EditStatusModal'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

const Responses = RepositoryFactory.get('responses')

export default {
  name: 'RespStatusModal',
  components: { EditStatusModal, LoaderWrapper },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    day: {
      type: String,
      default: '',
    },
    response: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      editId: -1,
      history: null,
      next: null,
      statuses,
      date: '',
      radio: null,
      pickerOptions: pickerOpt,
    }
  },
  computed: {
    ...mapGetters({ getLoading: 'loadDay/getLoading' }),
    editDate() {
      return this.response && this.editId >= 0 && statuses[this.editId]
        ? this.response[statuses[this.editId].field]
        : ''
    },
    isLoading() {
      return this.getLoading('Resp')
    },
    responseAuthor() {
      return this.response.user?.fio || 'Неизвестный пользователь'
    },
  },
  watch: {
    'response.status'() {
      this.beforeOpen()
    },
  },
  methods: {
    beforeOpen() {
      const { status } = this.response || {}

      this.history = status >= 0 ? this.statuses[status].history : null
      this.next =
        status >= 0 && this.statuses[status] ? this.statuses[status].next : null

      if (this.next) {
        if (this.radio === null) {
          this.radio = this.next[0]
        }
        if (!this.date && status === 0) {
          this.date = this.day + ' 00:00:00'
        }
      }
    },
    beforeClose() {
      this.history = null
      this.next = null
      this.radio = null
      this.date = ''
      this.$emit('close')
    },
    getDate(field) {
      const { [field]: date } = this.response || {}

      return this.dateToFormat(date, 'respStatusDate')
    },
    setDate(d = '', f = '', s = '', save = 0) {
      let date = d
      let field = f
      let status = s

      if (!field && this.next) {
        status = this.next.length === 1 ? this.next[0] : this.radio
        field = this.statuses[status] ? this.statuses[status].field : f
        date = this.date
      }
      if (this.response && field && status >= 0) {
        this.loading = true
        Responses.updateStatusResponse(this.response.id, {
          status,
          [field]: date,
        })
          .then(response => {
            const { data, status } = response

            if (status === 200 && data) {
              if (!save) {
                this.radio = null
              }
              this.date = ''
              this.$emit('updateStatus', { ...data, id: Number(data.id) })
            }
          })
          .catch(e => this.errHandler(e))
          .finally(() => (this.loading = false))
      }
    },
  },
}
</script>

<style lang="sass">
.status-modal
  .row-wrap
    margin-bottom: 16px
  .set-date-wrap
    display: flex
    justify-content: flex-start
    align-items: center
    margin-top: 8px
    .el-date-editor
      min-width: 270px
  .el-dialog__body
    color: #000
    *
      font-family: 'Rubik', sans-serif
    .date-at
      color: #67C23A
      font-size: 16px
      font-weight: bold
      margin-top: 8px
      margin-bottom: 4px
    .resp-time
      font-size: 14px
      font-weight: normal
      color: #98A9BC
      margin: 4px 0px
      text-transform: lowercase
    span
      font-size: 16px
      text-transform: uppercase
    p
      font-size: 16px
      text-transform: uppercase
      margin-bottom: 0px
      margin-top: 0px
      &.first
        text-transform: uppercase
        margin: 0px 0px 0px 40px
    .el-timeline-item
    .el-timeline-item__content
      font-size: 14px
      font-weight: bold
      margin-top: 8px
      color: #000
      button
        margin-left: 10px
      .response__author
        font-weight: 400
    .el-timeline-item__node
      border: 1px solid
    .el-timeline-item__timestamp
      margin-left: -30px
      margin-top: 8px!important
      font-size: 14px
      font-weight: normal
      color: #98A9BC
      margin: 0px
    .set-btn
      display: flex
      margin-left: 10px

.approve
  &__title
    margin-bottom: 4px
    font-size: 16px
  &__time
    margin-top: 6px
    color: #98A9BC
</style>
